export default __webpack_public_path__ + "static/media/qr_android.6dca6413.png";